/**
 * location.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 입지 탭에서 사용하는 데이터의 모음입니다.
 * 일부 데이터는 직접 입지 페이지 컴포넌트에 넣는 경우도 존재합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

// 주변시설 이미지
import img1 from 'assets/Desktop/images/parcelOut/faci01.jpg';
import img2 from 'assets/Desktop/images/parcelOut/faci02.jpg';
import img3 from 'assets/Desktop/images/parcelOut/faci03.jpg';
import img4 from 'assets/Desktop/images/parcelOut/faci04.jpg';
import img5 from 'assets/Desktop/images/parcelOut/faci05.jpg';
import img6 from 'assets/Desktop/images/parcelOut/faci06.jpg';
import img7 from 'assets/Desktop/images/parcelOut/faci07.jpg';
import img8 from 'assets/Desktop/images/parcelOut/faci08.jpg';
import img9 from 'assets/Desktop/images/parcelOut/faci09.jpg';
import img10 from 'assets/Desktop/images/parcelOut/faci10.jpg';
import img11 from 'assets/Desktop/images/parcelOut/faci11.jpg';
import img12 from 'assets/Desktop/images/parcelOut/faci12.jpg';
import img13 from 'assets/Desktop/images/parcelOut/faci13.jpg';
import img14 from 'assets/Desktop/images/parcelOut/faci14.jpg';
import img15 from 'assets/Desktop/images/parcelOut/faci15.jpg';
import img16 from 'assets/Desktop/images/parcelOut/faci16.jpg';
import img17 from 'assets/Desktop/images/parcelOut/faci17.jpg';
import img18 from 'assets/Desktop/images/parcelOut/faci18.jpg';
import img19 from 'assets/Desktop/images/parcelOut/faci19.jpg';
import img20 from 'assets/Desktop/images/parcelOut/faci20.jpg';
import img21 from 'assets/Desktop/images/parcelOut/faci21.jpg';
import img22 from 'assets/Desktop/images/parcelOut/faci22.jpg';

import PositionImg from 'assets/Desktop/images/parcelOut/cg_wide_map.png';
import PositionImgBig from 'assets/Desktop/images/parcelOut/cg_wide_map_big.png';
import wideBirdsView from 'assets/Desktop/images/parcelOut/cg_birds_view.jpg'

/**
 * 입지 탭에서 주변 시설의 하단 주변시설 리스트에 사용하는 데이터 목록.
 * 아래 데이터는 클릭 시 네이버 맵에 반영됩니다.
 */
export interface ILocation {
  img: string;
  title: string;
  address: string;
}

/**
 * 주변시설의 컨텐츠를 지정합니다.
 * 각각 대표 이미지, 타이틀, 네이버맵에 연결될 주소를 설정합니다.
 */
export const dataSlide: Array<ILocation> = [
  {
    img: img1,
    title: '봉선동 학원가밀집지역',
    address: '광주광역시 남구 봉선동 111-1'
  },
  {
    img: img2,
    title: '광주제석초등학교',
    address: '광주광역시 남구 봉선로51번길 14'
  },
  {
    img: img3,
    title: '봉선초',
    address: '광주광역시 남구 봉선중앙로118번길 4'
  },
  {
    img: img4,
    title: '주월중',
    address: '광주광역시 남구 주월동 1112'
  },
  {
    img: img5,
    title: '봉선중',
    address: '광주광역시 남구 봉선중길 14'
  },
  {
    img: img6,
    title: '문성중',
    address: '광주 남구 제석로 73'
  },
  {
    img: img7,
    title: '문성고',
    address: '광주광역시 남구 제석로 73'
  },
  {
    img: img8,
    title: '조선대',
    address: '광주광역시 동구 필문대로 309'
  },
  {
    img: img9,
    title: '남구문화정보도서관',
    address: '광주광역시 남구 봉선로 208 종합문화예술회관(청소년수련관)'
  },
  {
    img: img10,
    title: '남구청소년도서관',
    address: '광주광역시 남구 제석로 100'
  },
  {
    img: img11,
    title: '남광주농협 하나로마트 본점',
    address: '광주광역시 남구 대남대로 163'
  },
  {
    img: img12,
    title: '이마트(봉선점)',
    address: '광주광역시 남구 봉선로 198'
  },
  {
    img: img13,
    title: '봉선시장',
    address: '광주 남구 봉선1로47번길 7 봉선시장'
  },
  {
    img: img14,
    title: '백운 푸드스트리트존(글씨구조물)',
    address: '광주광역시 남구 봉선동1132-4'
  },
  {
    img: img15,
    title: '푸른길공원',
    address: '광주광역시 남구 주월동 434-2'
  },
  {
    img: img16,
    title: '월산근린공원',
    address: '광주광역시 남구 월산동 167'
  },
  {
    img: img17,
    title: '풍암생활 체육공원',
    address: '광주광역시 서구 풍암동 32-26'
  },
  {
    img: img18,
    title: '남구청',
    address: '광주광역시 남구 봉선로 1'
  },
  {
    img: img19,
    title: '광주기독병원',
    address: '광주 남구 양림로 37'
  },
  {
    img: img20,
    title: '백운광장역',
    address: '광주광역시 남구 주월동 1199'
  },
  {
    img: img21,
    title: '백운광장 푸른길 브릿지',
    address: '광주광역시 남구 주월동 1199'
  },
  {
    img: img22,
    title: '용산 IC',
    address: '광주광역시 동구 용산동 439-1'
  }
];

/**
 * @데스크탑
 * 입지 탭에서 위치 메뉴에서 사용하는 데이터 목록.
 */
export const titleContent = {
  tit: '광주가 선망하는 최선호 주거지답게\n완벽하게 조성되어 있는 생활 인프라',
  desc: '모두가 동경하는 교육 1번지',
  PositionImg,
  PositionImgBig,
  wideBirdsView,
  infoMap: `* 상기 개발계획은 사업주체, 국가기관, 지자체 및 기타 기관의 사업추진 중 변경, 지연, 취소될 수 있습니다.`,
  infoMap2: `* 본 홍보물의 일러스트(그림)는 소비자의 이해를 돕기 위해 제작된 것이므로, 실제와 다소 차이가 있을 수 있습니다.`,
  infoMap3: `* 대구권광역철도 관련 내용은 국토교통부 고시 제2021-342호 대구권 광역철도 건설사업 기본계획(변경) 및 국토교통부 고시 제2021-1017호 대구권 광역철도 건설사업 실시계획 변경(2차) 등을 참조한 것입니다.`
};

/**
 * @모바일
 * 입지 탭에서 위치 메뉴에서 사용하는 데이터 목록.
 */
export const titleSection = {
  tit: '광주가 선망하는 최선호 주거지답게 완벽하게 조성되어 있는 생활 인프라',
  desc: '모두가 동경하는 교육 1번지',
  PositionImg,
  PositionImgBig,
  wideBirdsView,
  infoMap: `* 상기 개발계획은 사업주체, 국가기관, 지자체 및 기타 기관의 사업추진 중 변경, 지연, 취소될 수 있습니다.`,
  infoMap2: `* 본 홍보물의 일러스트(그림)는 소비자의 이해를 돕기 위해 제작된 것이므로, 실제와 다소 차이가 있을 수 있습니다.`,
  infoMap3: `* 대구권광역철도 관련 내용은 국토교통부 고시 제2021-342호 대구권 광역철도 건설사업 기본계획(변경) 및 국토교통부 고시 제2021-1017호 대구권 광역철도 건설사업 실시계획 변경(2차) 등을 참조한 것입니다.`
};

// 입지 특정점 카피문구
export const contentSection = [
  {
    tit: `모두가 동경하는 교육 1번지`,
    desc: [
      '도보 통학이 가능한 초·중교를 비롯해 남고·여고·조선대 인접','다양한 학원들이 밀집한 광주 최대 학원가 인접', '남구문화정보도서관·남구청소년도서관 등 공공도서관 이용 가능'
    ]
  },
  {
    tit: 'e편한세상이 선보이는 특별한 주거 상품',
    desc: [
      '광주 최초 C2 HOUSE 특화 설계 적용','실내 골프연습장, 스크린 골프룸, 피트니스센터, 라운지 카페 등 입주민의 품격을 높이는 고급 커뮤니티 시설','유아놀이터가 있는 어린이집과 독서실, 스터디 카페를 갖춘 자녀들을 위한 다양한 공간 적용'
    ]
  },
  {
    tit: `삶의 질을 높여줄 생활 인프라`,
    desc: [
      '하나로마트(약 300m)·봉선시장(약 400m)·이마트(약 1.5km) 인접','반경 2km에 푸른길공원·봉선공원·광주사직공원·월산근린공원 등 위치','구청 및 관공서·금융·의료 등 편리한 생활 인프라'
    ]
  },
  {
    tit: '개발호재 가득한 미래 프리미엄',
    desc: [
      '도보 10분 거리에 광주도시철도 2호선 백운광장역 2026년 개통 예정\n<출처 : 광주광역시남구 공고 제2020 - 901호(2020. 7. 8.)>','백운광장 주변으로 新산업 복합문화 교류공간을 조성하는 "백운광장 도시재생 뉴딜사업" 2023년 예정\n < 출처 : 광주광역시 남구청 >'
    ]
  }
];
